import {
  AUTH_ADMIN,
  AUTH_CAPTAIN,
  AUTH_CS_AGENT,
  AUTH_CS_CAPTAIN,
  AUTH_CUSTOMER_SERVICE,
  AUTH_HO_LP,
  AUTH_HO_PRODUCT_MANAGER,
  AUTH_HO_QUALITY_ENGINEERING,
  AUTH_HUB_AREA_MANAGER,
  AUTH_HUB_AREA_MANAGER_VIEWONLY,
  AUTH_HUB_SHIFT_LEAD,
  AUTH_HUB_SPV,
  AUTH_INTERNAL_SALES,
  AUTH_PACKER,
  AUTH_HO_CS_SHIFT_LEAD,
  AUTH_PICKER,
  AUTH_PRODUCT_MANAGER,
  AUTH_QUALITY_ENGINEERING,
  AUTH_SHIFT_LEAD,
  AUTH_SUPPLY_CHAIN,
  AUTH_SPV_HUB,
  AUTH_SUPER_AREA_MANAGER,
  AUTH_SUPER_SHIFT_LEAD,
  AUTH_SUPER_SPV,
  type RolesKeyType,
} from 'constant/roles'
import {
  AUTH_HO_ASTRO_KITCHEN_MANAGER,
  AUTH_HO_ASTRO_KITCHEN_STAFF,
  AUTH_HO_CS_LEADER,
} from 'middleware/privateRoute'
import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import DynamicRouteHandler from './DynamicRoutingHelper'
import { PoolingMapRolesRBAC } from '../pages/PoolingMap/rbac'
import { CreateOrderRolesRBAC } from '../pages/CreateOrder/rbac'
import { DriverMonitoringRolesRBAC } from '../pages/DriverMonitoring/rbac'
import { AdditionalSLARolesRBAC } from '../pages/AdditionalSLA/rbac'
import { OngoingOrdersRBAC } from '../pages/OngoingOrdersV2/rbac'
import DynamicRouteHandlerV2 from './DynamicRoutingHelperV2'
import { AllOrderV2RolesRBAC } from '../pages/AllOrderV2/rbac'
import { AdditionalSLALogRolesRBAC } from '../pages/ASLALog/rbac'
import { ThreePLLogRolesRBAC } from '../pages/3plLog/rbac'
import { OrderDetailRolesRBAC } from '../pages/OrderDetail/rbac'

const CreateOrder = lazy(() => import('../pages/CreateOrder'))
const DriverMonitoring = lazy(() => import('../pages/DriverMonitoring'))
const PoolingMap = lazy(() => import('../pages/PoolingMap'))
const AllOrderV2 = lazy(() => import('../pages/AllOrderV2'))
const AdditionalSLA = lazy(() => import('../pages/AdditionalSLA'))
const ASLALog = lazy(() => import('../pages/ASLALog'))
const ThreePLLog = lazy(() => import('../pages/3plLog'))
const OrderDetail = lazy(() => import('../pages/OrderDetail'))
const KitchenMonitoring = lazy(() => import('../pages/KitchenMonitoring/KitchenMonitoring'))
const KitchenProcessingDetail = lazy(
  () => import('../pages/KitchenMonitoring/KitchenProcessingDetail'),
)
const KitchenCheckingDetail = lazy(() => import('../pages/KitchenMonitoring/KitchenCheckingDetail'))

type NamedRoutesType =
  | 'CreateOrderRouter'
  | 'DriverMonitoringRouter'
  | 'PoolingMapRouter'
  | 'NewOrderRouter'
  | 'AllOrderV2Router'
  | 'AdditionalSLARouter'
  | 'OnGoingOrdersRouter'
  | 'OnGoingOrdersV2Router'
  | 'ASLALogRouter'
  | 'ThreePLLogRouter'
  | 'OrderDetailRouter'
  | 'KitchenMonitoringRouter'
  | 'KitchenProcessingDetailRouter'
  | 'KitchenCheckingDetailRouter'
type PathListsType =
  | '/dashboard/create-order'
  | '/dashboard/driver-monitoring'
  | '/dashboard/pooling-map'
  | '/dashboard/order/:status'
  | `/dashboard/all-order-v2`
  | '/dashboard/additional-sla'
  | '/dashboard/ongoing-orders/:status'
  | '/dashboard/ASLA-log'
  | '/dashboard/3pl-log'
  | '/dashboard/details/order/:orderId'
  | '/dashboard/kitchen-monitoring'
  | '/dashboard/kitchen-monitoring/:orderId/processing'
  | '/dashboard/kitchen-monitoring/:orderId/checking'

type RouterInstanceType = RouterFeatureInterface<NamedRoutesType, PathListsType>

const CreateOrderRouter: RouterInstanceType = {
  name: 'CreateOrderRouter',
  Component: CreateOrder,
  path: '/dashboard/create-order',
  routeType: 'PRIVATE',

  allowedRoles: [AUTH_HO_ASTRO_KITCHEN_STAFF, AUTH_HO_ASTRO_KITCHEN_MANAGER],
  rbacPageID: CreateOrderRolesRBAC.pageID,
  isDashboard: true,
}

const DriverMonitoringRouter: RouterInstanceType = {
  name: 'DriverMonitoringRouter',
  Component: DriverMonitoring,
  path: '/dashboard/driver-monitoring',
  routeType: 'PRIVATE',

  allowedRoles: [
    'AUTH_HO_PRODUCT_MANAGER',
    'AUTH_HO_QUALITY_ENGINEERING',
    'AUTH_HUB_SHIFT_LEAD',
    'AUTH_HUB_SPV',
    'AUTH_HUB_AREA_MANAGER',
    'AUTH_PRODUCT_MANAGER',
    'AUTH_QUALITY_ENGINEERING',
    'AUTH_SUPPLY_CHAIN',
    'AUTH_HO_SUPPLY_CHAIN',
    'AUTH_SPV_HUB',
    'AUTH_SHIFT_LEAD',
  ],
  isDashboard: true,
  rbacPageID: DriverMonitoringRolesRBAC.pageID,
}

const NewOrderRouter: RouterInstanceType = {
  name: 'NewOrderRouter',
  Component: DynamicRouteHandler,
  path: '/dashboard/order/:status',
  routeType: 'PRIVATE',
  allowedRoles: [
    AUTH_PACKER,
    AUTH_CAPTAIN,
    AUTH_SHIFT_LEAD,
    AUTH_HO_ASTRO_KITCHEN_MANAGER,
    AUTH_HO_ASTRO_KITCHEN_STAFF,
    AUTH_QUALITY_ENGINEERING,
    AUTH_SPV_HUB,
    AUTH_HUB_SPV,
    AUTH_HUB_SHIFT_LEAD,
    AUTH_PICKER,
    AUTH_PRODUCT_MANAGER,
    AUTH_HO_PRODUCT_MANAGER,
    AUTH_HO_QUALITY_ENGINEERING,
    AUTH_SUPPLY_CHAIN,
    AUTH_HO_CS_LEADER,
    AUTH_CS_AGENT,
    AUTH_HO_LP,
  ],
  isDashboard: true,
}

const PoolingMapRouter: RouterInstanceType = {
  name: 'PoolingMapRouter',
  Component: PoolingMap,
  path: '/dashboard/pooling-map',
  routeType: 'PRIVATE',
  allowedRoles: [AUTH_PACKER, AUTH_ADMIN],
  rbacPageID: PoolingMapRolesRBAC.pageID,
  isDashboard: true,
}

export const AllOrderV2Router: RouterInstanceType = {
  name: 'AllOrderV2Router',
  Component: AllOrderV2,
  path: `/dashboard/all-order-v2`,
  routeType: 'PRIVATE',
  allowedRoles: [
    AUTH_ADMIN,
    AUTH_HO_ASTRO_KITCHEN_MANAGER,
    AUTH_HO_ASTRO_KITCHEN_STAFF,
    AUTH_HO_CS_LEADER,
    AUTH_HO_CS_SHIFT_LEAD,
    AUTH_CUSTOMER_SERVICE,
    AUTH_PRODUCT_MANAGER,
    AUTH_QUALITY_ENGINEERING,
    AUTH_SPV_HUB,
  ],
  rbacPageID: AllOrderV2RolesRBAC.pageID,
  isDashboard: true,
}
const AdditionalSLARouter: RouterInstanceType = {
  name: 'AdditionalSLARouter',
  Component: AdditionalSLA,
  path: '/dashboard/additional-sla',
  routeType: 'PRIVATE',
  allowedRoles: [
    AUTH_PACKER,
    AUTH_HO_CS_LEADER,
    AUTH_CUSTOMER_SERVICE,
    'AUTH_CS_AGENT',
    AUTH_ADMIN,
  ],
  rbacPageID: AdditionalSLARolesRBAC.pageID,
  isDashboard: true,
}

const OngoingOrdersRouter: RouterInstanceType = {
  name: 'OnGoingOrdersRouter',
  Component: DynamicRouteHandler,
  path: '/dashboard/order/:status',
  routeType: 'PRIVATE',
  allowedRoles: [
    AUTH_PACKER,
    AUTH_CAPTAIN,
    AUTH_SHIFT_LEAD,
    AUTH_HO_ASTRO_KITCHEN_MANAGER,
    AUTH_HO_ASTRO_KITCHEN_STAFF,
    AUTH_QUALITY_ENGINEERING,
    AUTH_SPV_HUB,
    AUTH_HUB_SPV,
    AUTH_HUB_SHIFT_LEAD,
    AUTH_PICKER,
    AUTH_PRODUCT_MANAGER,
    AUTH_HO_PRODUCT_MANAGER,
    AUTH_HO_QUALITY_ENGINEERING,
    AUTH_SUPPLY_CHAIN,
    AUTH_HO_CS_LEADER,
    AUTH_CS_AGENT,
    AUTH_HO_LP,
  ],
  isDashboard: true,
}

const OngoingOrdersV2Router: RouterInstanceType = {
  name: 'OnGoingOrdersV2Router',
  Component: DynamicRouteHandlerV2,
  path: '/dashboard/ongoing-orders/:status',
  routeType: 'PRIVATE',
  rbacPageID: OngoingOrdersRBAC.pageID,
  allowedRoles: [AUTH_ADMIN],
  isDashboard: true,
}
const ASLALogRouter: RouterInstanceType = {
  name: 'ASLALogRouter',
  Component: ASLALog,
  path: '/dashboard/ASLA-log',
  routeType: 'PRIVATE',
  allowedRoles: [AUTH_ADMIN],
  rbacPageID: AdditionalSLALogRolesRBAC.pageID,
  isDashboard: true,
}
const ThreePLLogRouter: RouterInstanceType = {
  name: 'ThreePLLogRouter',
  Component: ThreePLLog,
  path: '/dashboard/3pl-log',
  routeType: 'PRIVATE',
  allowedRoles: [AUTH_ADMIN],
  rbacPageID: ThreePLLogRolesRBAC.pageID,
  isDashboard: true,
}

const OrderDetailRouter: RouterInstanceType = {
  name: 'OrderDetailRouter',
  Component: OrderDetail,
  path: '/dashboard/details/order/:orderId',
  routeType: 'PRIVATE',
  allowedRoles: [
    AUTH_ADMIN,
    AUTH_CS_CAPTAIN,
    AUTH_CAPTAIN,
    AUTH_SPV_HUB,
    AUTH_CUSTOMER_SERVICE,
    AUTH_HO_CS_LEADER,
    AUTH_HO_LP,
    AUTH_CS_AGENT,
    AUTH_HUB_AREA_MANAGER,
    AUTH_HUB_SPV,
    AUTH_HUB_SHIFT_LEAD,
    AUTH_SUPER_AREA_MANAGER,
    AUTH_SUPER_SPV as RolesKeyType,
    AUTH_SUPER_SHIFT_LEAD as RolesKeyType,
    AUTH_INTERNAL_SALES as RolesKeyType,
    AUTH_HO_ASTRO_KITCHEN_MANAGER,
    AUTH_HO_ASTRO_KITCHEN_STAFF,
    AUTH_HO_PRODUCT_MANAGER,
    AUTH_HO_QUALITY_ENGINEERING,
    AUTH_HUB_AREA_MANAGER_VIEWONLY,
  ],
  rbacPageID: OrderDetailRolesRBAC.pageID,
  isDashboard: true,
}

const KitchenMonitoringRouter: RouterInstanceType = {
  name: 'KitchenMonitoringRouter',
  Component: KitchenMonitoring,
  path: '/dashboard/kitchen-monitoring',
  routeType: 'PRIVATE',
  allowedRoles: [AUTH_ADMIN, AUTH_HO_ASTRO_KITCHEN_MANAGER, AUTH_HO_ASTRO_KITCHEN_STAFF],
  isDashboard: true,
}

const KitchenProcessingDetailRouter: RouterInstanceType = {
  name: 'KitchenProcessingDetailRouter',
  Component: KitchenProcessingDetail,
  path: '/dashboard/kitchen-monitoring/:orderId/processing',
  routeType: 'PRIVATE',
  allowedRoles: KitchenMonitoringRouter.allowedRoles,
  isDashboard: true,
}

const KitchenCheckingDetailRouter: RouterInstanceType = {
  name: 'KitchenCheckingDetailRouter',
  Component: KitchenCheckingDetail,
  path: '/dashboard/kitchen-monitoring/:orderId/checking',
  routeType: 'PRIVATE',
  allowedRoles: KitchenMonitoringRouter.allowedRoles,
  isDashboard: true,
}

const OrderRouter = [
  CreateOrderRouter,
  DriverMonitoringRouter,
  PoolingMapRouter,
  AllOrderV2Router,
  AdditionalSLARouter,
  OngoingOrdersRouter,
  OngoingOrdersV2Router,
  ASLALogRouter,
  ThreePLLogRouter,
  OrderDetailRouter,
  KitchenMonitoringRouter,
  KitchenProcessingDetailRouter,
  KitchenCheckingDetailRouter,
]

export const OrderRouterDetail = generateRouterDetail(OrderRouter)

export const OnGoingRoutes = {
  newOrder: '/dashboard/order/new-order',
  upcomingOrder: '/dashboard/order/upcoming-order',
  backToHub: '/dashboard/order/back-to-hub',
  picking: '/dashboard/order/picking',
  packing: '/dashboard/order/packing',
  onDelivery: '/dashboard/order/on-delivery',
  waitingConfirmation: '/dashboard/order/waiting-confirmation',
  readyForDelivery: '/dashboard/order/ready-for-delivery',
}

export const OnGoingV2Routes = {
  newOrder: '/dashboard/ongoing-orders/new-order',
  upcomingOrder: '/dashboard/ongoing-orders/upcoming',
  backToHub: '/dashboard/ongoing-orders/back-to-hub',
  picking: '/dashboard/ongoing-orders/picking',
  packing: '/dashboard/ongoing-orders/packing',
  onDelivery: '/dashboard/ongoing-orders/on-delivery',
  waitingConfirmation: '/dashboard/ongoing-orders/waiting-confirmation',
  waitingOrder: '/dashboard/ongoing-orders/packing-integration',
  waitingForDelivery: '/dashboard/ongoing-orders/waiting-for-delivery',
  waitingKitchen: '/dashboard/ongoing-orders/waiting-kitchen',
}

export default OrderRouter
